import { Redirect, Stack } from "expo-router";
import "react-native-reanimated";
import { useAppFont } from "@/hooks/useAppFont";
import { Platform } from "react-native";

export default function RootLayout() {
  const [loaded] = useAppFont();

  if (Platform.OS === "web") {
    return <Redirect href="/" />;
  }

  if (!loaded) {
    // Async font loading only occurs in development.
    return null;
  }

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="rate-us" options={{ headerShown: false }} />
      <Stack.Screen name="rate-us-detail" options={{ headerShown: false }} />
      <Stack.Screen name="onboard" options={{ headerShown: false }} />
      <Stack.Screen name="onboard-success" options={{ headerShown: false }} />
      <Stack.Screen name="onboard-paywall" options={{ headerShown: false }} />
      <Stack.Screen name="onboard-paywall-offer" options={{ headerShown: false }} />
    </Stack>
  );
}
